import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import TierSidebarCard from '../../../DeviationViews/TierSidebarCard';
import { ResourceType } from '../../../types/resource';
import SidebarBlock from '../../_partials/SidebarBlock';
import Placeholder from '../../_partials/Placeholder';
import { TierStreamType } from './types';
import lodashTimes from 'lodash/times';
import s from './TiersBlock.scss';
export var TiersBlock = function (_a) {
    var streamKey = _a.streamKey, deviation = _a.deviation, tiers = _a.tiers, isLoading = _a.isLoading;
    var t = useTranslation().t;
    var _b = useSubscriptionTier(deviation), tier = _b.tier, isTier = _b.isTier;
    var author = tier === null || tier === void 0 ? void 0 : tier.author;
    var isSelectedTierBlock = streamKey === 'selectedTier' && !!tier;
    var seeAll = useMemo(function () { return ({
        href: (author === null || author === void 0 ? void 0 : author.username) && Url.userLink(author.username, 'subscriptions'),
        biData: {
            evid: BiEventType.VIEW_SUBSCRIPTION_TAB,
            referral_info: isTier
                ? ReferralType.COMPARE_TIER_UNIQUE
                : ReferralType.COMPARE_CONTENT_PAGE,
        },
    }); }, [isTier, author === null || author === void 0 ? void 0 : author.username]);
    var hasTiers = tiers && tiers.length;
    var isValidBlock = isSelectedTierBlock || hasTiers;
    var member_subscriptions = useFlag('member_subscriptions');
    if (!isValidBlock || !member_subscriptions) {
        return null;
    }
    var moreTiersTitle = t('sidebar.blockTitle.moreTiers', {
        author: author === null || author === void 0 ? void 0 : author.username,
    });
    var isShowingPlaceHolders = !isSelectedTierBlock && isLoading;
    var isShowingTierList = !isSelectedTierBlock && !isLoading && hasTiers;
    return (React.createElement(BiLoggerContextProvider, { value: { sectionname: streamKey } },
        React.createElement(SidebarBlock, { streamKey: streamKey, headerClassname: s['header'], titleClassname: s['title'], linkClassname: s['link'], isLoading: isLoading, seeAll: seeAll, titleOverride: streamKey === 'moreTiers' ? moreTiersTitle : undefined },
            isSelectedTierBlock && (React.createElement(TierSidebarCard, { className: classnames(s['selected-tier'], s['tier']), deviation: tier, showEdit: true, noClickOrView: true })),
            isShowingPlaceHolders &&
                lodashTimes(3, function (index) { return (React.createElement(Placeholder, { key: index, className: s['tier'] })); }),
            isShowingTierList &&
                tiers
                    // backend can do strange stuff...
                    .filter(function (otherTier) { return !!otherTier; })
                    .slice(0, 3)
                    .map(function (otherTier) { return (React.createElement(TierSidebarCard, { biData: {
                        evid: BiEventType.VIEW_TIER_UNIQUE,
                        referral_info: streamKey === TierStreamType.InTiers
                            ? ReferralType.SIDE_BAR_CONTENT_PAGE
                            : ReferralType.SIDE_BAR_TIER_UNIQUE,
                        itemid: otherTier.deviationId,
                        typeid: ResourceType.TIER,
                    }, key: otherTier.deviationId, className: s['tier'], deviation: otherTier, 
                    // design decision: don't allow editing of other tiers from a tier page
                    showEdit: !isTier })); }))));
};
TiersBlock.displayName = 'TiersBlock';
export default TiersBlock;
//# sourceMappingURL=TiersBlock.js.map